/**
 * The internal dependencies.
 */
import { registerFieldComponent } from 'lib/registry';
import NumberField from 'components/field';

registerFieldComponent('number', NumberField);



// WEBPACK FOOTER //
// assets/react/bootstrap.js